import React from 'react';
import '../styles/Highlights.scss';
import AnimatedCounter from './AnimatedCounter';
import wedding from '../assets/h3.png';
import corporate from '../assets/corporate.jpg';
import banquet from '../assets/banquet.jpg';
import together from '../assets/gettogether.jpg';
import pool from '../assets/pool-party.jpg';


export default function LeisureAmenities() {
    return (
        <section id="" className="highlights">
            <div className="container">
                <h2>Leisure Amenities (Available at Additional Cost)</h2>
                <p className="lead">A Lifestyle Destination that Grows Your Wealth.</p>


                <div className="grid">
                    <article className="e-card">
                        <div className="event">
                            <img src={wedding} alt='destination-wedding'></img>
                        </div>
                        <div className='e-card-text'>
                            <h3>Destination Wedding</h3>
                            <p>Celebrate life’s most cherished moments amidst nature. Lonavalley’s grand venues create unforgettable destination weddings with timeless memories.</p>

                        </div>

                    </article>


                    <article className="e-card">
                        <div className="event">
                            <img src={corporate} alt='corporate-event'></img>
                        </div>
                        <div className='e-card-text'>
                            <h3>Corporate Event</h3>
                            <p>Inspire your team in a refreshing natural setting. Perfect for offsites, conferences, and leadership meets away from the city.</p>
                        </div>
                    </article>


                    <article className="e-card">
                        <div className="event">
                            <img src={banquet} alt='banquet hall'></img>
                        </div>
                        <div className='e-card-text'>
                            <h3>Banquet Hall</h3>
                            <p>A versatile, elegant venue for weddings, social gatherings, and community celebrations within a premium resort environment.</p>
                        </div>

                    </article>

                    <article className="e-card">
                        <div className="event">
                            <img src={pool} alt='pool party area'></img>
                        </div>
                        <div className='e-card-text'>
                            <h3>Pool Party Area</h3>
                            <p>Relax, unwind, and celebrate by the poolside. An exclusive space designed for leisure, parties, and fun-filled evenings.</p>
                        </div>

                    </article>

                    {/* <article className="e-card">
                        <div className="event">
                            <img src={together} alt='get together'></img>
                        </div>

                        <div className='e-card-text'>
                            <h3>Get Togethers</h3>
                            <p>From family reunions to friendly catch-ups, Lonavalley offers the perfect backdrop for intimate get-togethers and joyous moments.</p>
                        </div>

                    </article> */}
                </div>
            </div >
        </section >
    );
}